import { useContext, useEffect, useState } from "react";
import logo_white from "../../assets/images/logo_white.png";
import logo from "../../assets/images/logo.png";
import { LocaleContext } from "../../contexts/LocaleContext";
import { useNavigate } from "react-router-dom";
import {authService} from "../../services/authService";
import tokenService from "../../services/tokenService";
import { useAuth } from "../../hooks/useAuth";

const Login = () => {
const {t}=useContext(LocaleContext);
const navigate=useNavigate();
const initialForm={
  userName:"",
  password:""
}
const [formData,setFormData]=useState(initialForm);
const [error,setError]=useState("");
const [loading,setLoading]=useState(false);
const { login, isAuthenticated } = useAuth();

useEffect(() => {
  if (isAuthenticated) {
    navigate("/dashboard");
  }
}, []);

const handleChange=(e)=>{
  const {name,value}=e.target;
  setFormData({...formData,[name]:value});
}
const handleLogin = async () => {
  try {
    setLoading(true);
    setError("");

    const response = await authService.login(formData);

    if (!response.isSuccess) {
      let key = "";

      response.errors.forEach((err) => {
        if (err === "Invalid credentials.")
          key = "invalidCredentials";

        if (err === "Access denied.")
          key = "accessDenied";

        if (err === "User is inactive.")
          key = "userInactive";
      });

      setError(t(key));
      return;
    }

    login(response.value);

    navigate("/dashboard");

  } catch (error) {
    setError(t("anErrorOccurredPleaseTryAgainLater"));
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  return (
    <section className="section-login">
      <div className="row g-0">
        <div className="col-12 col-md-4">
          <div className="login-left-side">
            <div className="flex-center">
              <div className="login-logo-box">
                <img src={logo} alt="Logo" />
              </div>
            </div>
            <div className="login form">
              <div className="form-group">
                <label htmlFor="userName">{t("userName")}</label>
                <input
                  className="form-control"
                  type="text"
                  id="userName"
                  name="userName"
                  placeholder={t("userName")}
                  value={formData.userName}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">{t("password")}</label>
                <input
                  className="form-control"
                  type="password"
                  id="password"
                  name="password"
                  placeholder={t("password")}
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <span className="text-danger">{error}</span>
              </div>
              <div className="form-group">
                {loading && (
                  <button className="btn-default w-100 disabled">{t("login")}...</button>
                )}
                 {!loading && (
                  <button onClick={handleLogin} className="btn-default w-100">{t("login")}</button>
                )}
              </div>
            </div>
          </div>
        </div>
         <div className="col-12 col-md-8">
          <div className="login-image-side flex-center">
            <div className="login-banner-image-box">
              <img src={logo_white} alt="Login Banner" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
